import React from "react";
import CountDown from "./CountDown/CountDown";
import CalendarComponent from "./Calendar/Calendar";

const CalendarAndCountDown = (props: any) => {
    const { userInfor, locale, isOffboarding = false, isLastAccess = false} = props;
    return (
        <>
        <CountDown startDate={isOffboarding ? !isLastAccess ? userInfor?.last_working_date : userInfor?.last_access_date :userInfor?.start_date} isOffboarding={isOffboarding} isLastAccess={isLastAccess} locale={locale} />
        <CalendarComponent userInfor={userInfor} isLastAccess={isLastAccess} isOffboarding={isOffboarding} locale={locale}/>
        </>
    )
};

export default CalendarAndCountDown;